import styled from "styled-components";

const ReportManagementDetailTableRowColumn = styled.td`
    width: ${({ width }) => width ? `${width}%` : 'auto'};
    max-width: 0 !important;
    padding: 0.6rem !important;
    vertical-align: middle;
`;

export default ReportManagementDetailTableRowColumn;